module.exports = __webpack_public_path__ + "img/top.2216248.png";